import { useState } from "react";
import { ProgressBar, Step } from "react-step-progress-bar";

const MultiProgressBar = ({
  page,
  onPageNumberClick,
  onButtonClick,
  formComplete,
}) => {
  const [customeAccomplish, setCustomAccomplish] = useState(false);

  const handleFirstClick = () => {
    // setCustomAccomplish(!customeAccomplish);
    onPageNumberClick("1");
    onButtonClick("pageone");
    setCustomAccomplish(true);
  };
  var stepPercentage = 0;
  if (page === "pageone") {
    stepPercentage = 16;
  } else if (page === "pagetwo") {
    stepPercentage = 49.5;
  } else if (page === "pagethree") {
    stepPercentage = 82.5;
  } else if (page === "pagefour") {
    stepPercentage = 100;
  } else {
    stepPercentage = 0;
  }

  return (
    <ProgressBar percent={stepPercentage}>
      <Step>
        {({ accomplished, index }) => (
          <div
            className={`indexedStep ${
              page !== "pageone" ? "accomplished" : null
            }`}
            onClick={() => onPageNumberClick("1")}
            // onClick={() => index + 1}
          >
            KYC
          </div>
        )}
      </Step>
      <Step>
        {({ accomplished, index }) => (
          <div
            className={`indexedStep ${
              page === "pagethree" || page === "pagefour"
                ? "accomplished"
                : null
            }`}
            onClick={() => onPageNumberClick("2")}
          >
            Finance
          </div>
        )}
      </Step>
      <Step>
        {({ accomplished, index }) => (
          <div
            className={`indexedStep ${
              page === "pagefour" ? "accomplished" : null
            }`}
            onClick={() => onPageNumberClick("3")}
          >
            SPA
          </div>
        )}
      </Step>
      <Step>
        {({ accomplished, index }) => (
          <div
            className={`indexedStep ${
              page === "pagefour" ? "accomplished" : null
            }`}
            onClick={() => onPageNumberClick("4")}
          >
            Confirm
          </div>
        )}
      </Step>
    </ProgressBar>
  );
};

export default MultiProgressBar;
